import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'react-bootstrap';
import handTiny from '../../static/images/handtinyblack.gif';

class NavItemSeparator extends React.Component {
  render() {
    return (
      <div className={this.props.className} role="separator" alt="menu item separator">
        <Image
          thumbnail
          fluid
          alt="image menu item separator"
          src={handTiny}
        />
      </div>);
  }
}

NavItemSeparator.propTypes = {
  className: PropTypes.string,
};


export default NavItemSeparator;